import { FieldType, FieldTypes } from "./field-types";

export class ReportField {

    public static getFieldTypeInstance(type: string, name: string, has_other: boolean, required: boolean, multiple: boolean, placeholder: string, orientation: string, default_value: string | null, additional_options: any, additional_validation_rules: any, columns: any[]): FieldType {
        const className = type[0].toUpperCase() + type.slice(1);

        if (FieldTypes[className] === undefined || FieldTypes[className] === null) {
            throw new Error(`Class type of \'${className}\' is not available`);
        }

        return new FieldTypes[className](name, has_other, required, multiple, placeholder, orientation, default_value, additional_options, additional_validation_rules, columns);
    }
}